// jshint esversion: 8

export default {
  SET_DATA: (state, payload) => state.data = payload,
  PUSH_DATA: (state, payload) => state.data.push(payload)
};
